import asyncActionType from "../../utils/asyncActionType";

export const FETCH_VENDORS = asyncActionType("FETCH_VENDORS");

export const CREATE_INVOICE = asyncActionType("CREATE_INVOICE");
export const FETCH_BOXES = asyncActionType("FETCH_BOXES");
export const FETCH_INVOICE = asyncActionType("FETCH_INVOICE");
export const FETCH_INVOICES = asyncActionType("FETCH_INVOICES");
